export const attributiveDataCustomFormatters = {
  coordinate: ({ values, key }) => values.coordinates?.[key] ?? '',
};
